// src/hooks/useUpdateClienteIntermedioWithUsuario.ts
import type { UpdateClienteFinalPayload } from "@/interfaces/user.interface";
import { axiosInstance } from "@retro-ia/shared/axios";
import {
  useMutation,
  useQueryClient,
  type QueryKey,
} from "@tanstack/react-query";
import { toast } from "sonner";

export const useUpdateClienteFinalWithUsuario = (options?: {
  queryKey?: QueryKey;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: UpdateClienteFinalPayload) => {
      const res = await axiosInstance.patch(`/clientes-finales/${id}`, data, {
        withCredentials: true,
      });
      return res.data;
    },
    onSuccess: () => {
      if (options?.queryKey) {
        queryClient.invalidateQueries({ queryKey: options.queryKey });
      } else {
        queryClient.invalidateQueries({
          queryKey: ["clientesFinales"],
        });
      }
      queryClient.invalidateQueries({ queryKey: ["usuarioInfo"] });
      toast.success("Cliente final actualizado correctamente.");
    },
    onError: () => {
      toast.error("Error al actualizar");
    },
  });
};
